import * as Types from '@Global/apollo/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateTelegramStarsInvoiceLinkMutationVariables = Types.Exact<{
  currency: Types.Currency;
  amount: Types.Scalars['MoneyAmount']['input'];
}>;


export type CreateTelegramStarsInvoiceLinkMutation = { __typename?: 'Mutation', createTelegramStarsInvoiceLink: string };


export const CreateTelegramStarsInvoiceLinkDocument = gql`
    mutation createTelegramStarsInvoiceLink($currency: Currency!, $amount: MoneyAmount!) {
  createTelegramStarsInvoiceLink(currency: $currency, amount: $amount)
}
    `;
export type CreateTelegramStarsInvoiceLinkMutationFn = Apollo.MutationFunction<CreateTelegramStarsInvoiceLinkMutation, CreateTelegramStarsInvoiceLinkMutationVariables>;

/**
 * __useCreateTelegramStarsInvoiceLinkMutation__
 *
 * To run a mutation, you first call `useCreateTelegramStarsInvoiceLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTelegramStarsInvoiceLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTelegramStarsInvoiceLinkMutation, { data, loading, error }] = useCreateTelegramStarsInvoiceLinkMutation({
 *   variables: {
 *      currency: // value for 'currency'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useCreateTelegramStarsInvoiceLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateTelegramStarsInvoiceLinkMutation, CreateTelegramStarsInvoiceLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTelegramStarsInvoiceLinkMutation, CreateTelegramStarsInvoiceLinkMutationVariables>(CreateTelegramStarsInvoiceLinkDocument, options);
      }
export type CreateTelegramStarsInvoiceLinkMutationHookResult = ReturnType<typeof useCreateTelegramStarsInvoiceLinkMutation>;
export type CreateTelegramStarsInvoiceLinkMutationResult = Apollo.MutationResult<CreateTelegramStarsInvoiceLinkMutation>;
export type CreateTelegramStarsInvoiceLinkMutationOptions = Apollo.BaseMutationOptions<CreateTelegramStarsInvoiceLinkMutation, CreateTelegramStarsInvoiceLinkMutationVariables>;